import PropTypes from 'prop-types'

/**
 * @typedef {Object} TachographCard
 * Driver card for use in digital tachographs
 *
 * @property {String} driverCardId          - The ID of the tachograph card.
 * @property {String} cardNumber            - The driver card number.
 * @property {String} cardCountry           - The county code for the driver card in ISO 3166-1 alpha-2 format.
 * @property {String} [driverId]            - The ID of the driver which the card is assigned to. Absent for unassigned
 *                                            cards. Only cards of type DRIVER can be assigned to drivers.
 */
export const tachographCardPropType = PropTypes.shape({
    cardCountry: PropTypes.string.isRequired,
    cardNumber: PropTypes.string.isRequired,
    driverCardId: PropTypes.string,
    driverId: PropTypes.string
})
